export default "__VITE_ASSET__OcuX4sal__"